import { useStore } from "@nanostores/react"
import { isEthereumAddress } from "class-validator"
import { parseUnits } from "ethers/lib/utils"
import { memo, useMemo } from "react"
import { useAccount, useConnect, useTransaction, useContractWrite } from "wagmi"
import { useAmount, assetAtom, decimalAtom } from "../atom/atom"
import { erc20TransferAbi } from "../constant"

export const Transaction = memo(() => {
  const amount = useAmount()
  const { asset_key, tag } = useStore(assetAtom)
  const isEthereumContract = useMemo(() => isEthereumAddress(asset_key), [asset_key])

  if (!amount) return <></>

  if (!isEthereumContract)
    return (
      <div className="mt-8 flex flex-col items-center justify-center text-xs text-gray-400">
        Manual Transfer
        <div>address: {asset_key}</div>
        {tag && <div>tag: {tag}</div>}
      </div>
    )

  return <EthTransation />
})

const EthTransation = memo(() => {
  const [{ data: account, loading }, disconnect] = useAccount()

  return (
    <div className="mt-8 flex flex-col items-center justify-center gap-1">
      {!account && <WalletConnect />}
      {account && (
        <div className="flex flex-col items-center justify-center gap-1 break-all text-center text-gray-400">
          <div className=" text-xs">address:{account.address}</div>
          <button className="p-1 text-red-400 " disabled={loading} onClick={disconnect}>
            Disconnect
          </button>
          <SendEthTransation />
        </div>
      )}
      <div className=" text-xs text-gray-400">Use on-chain wallet</div>
    </div>
  )
})

const defaultWalletNams: { [key: number]: string } = {
  0: "MetaMask",
  1: "WalletConnect",
  2: "Coinbase Wallet",
}
const WalletConnect = memo(() => {
  const [
    {
      data: { connectors },
      loading,
    },
    connect,
  ] = useConnect()
  return (
    <>
      {connectors.map((connector, index) => (
        <button key={connector.id} className="w-full p-1 text-primary" disabled={loading} onClick={() => connect(connector)}>
          Connect {connector.name || defaultWalletNams[index]}
          {!connector.ready && " (not installed)"}
        </button>
      ))}
    </>
  )
})

const SendEthTransation = memo(() => {
  const { asset_key: contract, destination: to } = useStore(assetAtom)
  const isEthereum = useMemo(() => contract === "0x0000000000000000000000000000000000000000", [contract])

  const amount = useAmount()
  // eslint-disable-next-line react-memo/require-usememo
  let { data: decimal } = useStore(decimalAtom)
  decimal = isEthereum ? 18 : decimal

  const amountUnit = useMemo(() => {
    if (!decimal || !amount) return
    return parseUnits(amount, decimal)
  }, [amount, decimal])

  const [{ loading: transactionLoading, error: transationError }, sendTransaction] = useTransaction({
    request: {
      to: to,
      value: amountUnit || 0,
    },
  })

  const [{ loading: contractLoading }, write] = useContractWrite(
    {
      addressOrName: contract || "",
      contractInterface: erc20TransferAbi,
    },
    "transfer",
    {
      args: [to, amountUnit],
      overrides: {
        gasLimit: 21000,
      },
    }
  )

  return (
    <>
      <button
        className=" w-full p-1 text-primary"
        disabled={!amountUnit || contractLoading || transactionLoading}
        onClick={() => {
          if (isEthereum) sendTransaction()
          else write()
        }}
      >
        Send Transation
      </button>
      {transationError && <div className=" text-red-400">Error: {transationError.message}</div>}
    </>
  )
})
